import React, { ReactNode } from "react";
import useNotificationListener from "../../../hooks/useNotificationListener";

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
  children,
}) => {
  useNotificationListener();

  return <>{children}</>;
};

export default NotificationProvider;
